import React from 'react';

function Speaker(): JSX.Element {
  return (
    <div className="card">
      <h2>🎤 Featured Speaker</h2>
      <h3>Speaker Name</h3>
      <p><strong>Topic:</strong> Speaker Topic</p>
      <p>Speaker bio or description goes here. Tell attendees a little about the speaker and what they can expect to learn or hear about.</p>
    </div>
  );
}

export default Speaker;
